export const Male = 1;
export const Female = 2;

export type GenderValueString = 'any' | 'male' | 'female';
